module.exports = __webpack_public_path__ + "img/coming-soon.e4738d0d.svg";